import React from 'react';
import './OutroCorrect.css';
import Button from '../Button/Button';
import { useTranslation } from 'react-i18next';
import Heading from '../Heading/Heading';
const qr_nl = new URL('./graphics/DNDT_QR_Kiosk_Brussels_NL.png', import.meta.url);
const qr_fr = new URL('./graphics/DNDT_QR_Kiosk_Brussels_FR.png', import.meta.url);
const germany_nl = new URL('./graphics/germany--nl.png', import.meta.url);
const germany_fr = new URL('./graphics/germany--fr.png', import.meta.url);
const hotelspecials_nl = new URL('./graphics/hotelspecials--nl.jpg', import.meta.url);
const hotelspecials_fr = new URL('./graphics/hotelspecials--fr.jpg', import.meta.url);

const OutroCorrect = ({ language, location }) => {

     // get translations
    const {t} = useTranslation();

    // render html
    return(
        <div className={`outroCorrect`}>
            <div className={`outroCorrect__box`}>
                <div className={`outroCorrect__block`}> 
                    <Heading>{ t('outro_correct_title') }</Heading>
                    <p>
                        { t('outro_correct_description') }<br/>
                        <strong>{ t(`outro_correct_anwser_${location}`) }</strong>
                    </p>
                </div>
                <div className={`outroCorrect__block`}> 
                    <Heading size="s">{ t('outro_correct_subtitle') }</Heading>
                    <div className={`outroCorrect__qr`}>
                        {(language === 'fr') ? (
                            <img src={qr_fr} alt="QR" />
                        ) : (
                            <img src={qr_nl} alt="QR" />
                        )}
                    </div>
                </div>
                <div className={`outroCorrect__block`}> 
                    <div className={`outroCorrect__partners`}>
                        {(language === 'fr') ? (
                            <>
                                <img src={hotelspecials_fr} alt="" />
                                <img src={germany_fr} alt="" />
                            </>
                        ) : (
                            <>
                                <img src={hotelspecials_nl} alt="" />
                                <img src={germany_nl} alt="" />
                            </>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default OutroCorrect;